import "react-responsive-carousel/lib/styles/carousel.min.css";
import React from "react";
import {useAppDispatch} from "../../../app/hooks";
import {focusVehicle, VehicleDetails} from "../../chatbotSlice";

interface CarsSliderLeftIconProps {
    currentVehicleIndex: number,
    setCurrentVehicleIndex: (cur: number) => void,
    vehicles: VehicleDetails[]
}

export const VehicleSliderLeftIcon: React.FC<CarsSliderLeftIconProps> = ({
                                                                             currentVehicleIndex,
                                                                             setCurrentVehicleIndex,
                                                                             vehicles
                                                                         }) => {

    const dispatch = useAppDispatch();

    const setFocusVehicle = (value: string) => {
        dispatch(focusVehicle({VIN: value}));
    };

    return <div
        key="left"
        onClick={() => {
            if (currentVehicleIndex === 0) {
                if (!!vehicles.length) {
                    setFocusVehicle(vehicles[vehicles.length - 1].vin);
                }
                setCurrentVehicleIndex(vehicles.length - 1);
            } else {
                if (!!vehicles.length) {
                    setFocusVehicle(vehicles[currentVehicleIndex - 1].vin);
                }
                setCurrentVehicleIndex(currentVehicleIndex - 1);
            }
        }}
        className="flex w-[32px] h-[32px] justify-center items-center !absolute bottom-[7px] z-50 left-0 border-[1.5px] border-gray-800 -translate-y-2/4 bg-white hover:bg-gray-300 rounded-full active:bg-gray-700 hover:cursor-pointer"
    >
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.5 15.8332L6.66667 9.99984L12.5 4.1665"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    </div>
}
